document.querySelectorAll('*[data-tooltip]').forEach((el) => {
    el.addEventListener('mouseenter', () => {
        showTooltipInEl(el);
    }, { passive: true });
    el.addEventListener('touchstart', () => {
        showTooltipInEl(el);
    }, { passive: true });
    el.addEventListener('mouseleave', () => {
        hideTooltipInEl();
    }, { passive: true });
});

window.addEventListener('touchmove', () => {
    hideTooltipInEl();
}, {passive: true});

let elTooltipInEl;

function showTooltipInEl(el) {
    hideTooltipInEl();
    const div = document.createElement('div');
    div.className = 'TooltipGlobal';
    div.innerHTML = el.dataset.tooltip;
    div.style.position = 'fixed'

    const pos = el.getBoundingClientRect();
    div.style.top = `${pos.top+pos.height}px`;
    div.style.left = `${pos.left+(pos.width/2)}px`;

    document.body.append(div);
    elTooltipInEl = div;
}

function hideTooltipInEl() {
    if(elTooltipInEl) {
        elTooltipInEl.remove();
    }
}
